'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import Link from 'next/link.js';
import { useMemo, useState } from 'react';
import { IconChevronRight } from '../../../svg/icons/icon-chevron-right.js';
import { groupItems } from '../tiered-nav.js';
import { MobileFullPageMenu } from './mobile-full-page-menu.js';
import { MobileTakeover } from './mobile-takeover.js';

const BrowseCoachingItem = ({ url, label, onClick, showChevron, }) => {
    return url ? (jsxs(Link, { className: `flex items-center justify-between text-xl`, href: url, onClick: onClick, children: [jsx("span", { children: label }), showChevron ? jsx(IconChevronRight, { className: "size-6" }) : null] })) : (jsxs("button", { type: "button", className: "flex w-full items-center justify-between text-xl", onClick: onClick, children: [jsx("span", { children: label }), showChevron ? jsx(IconChevronRight, { className: "size-6" }) : null] }));
};
const BrowseCoachingItemGroup = ({ items, setSelectedGroups, onClose, }) => {
    return (jsx("div", { className: "flex flex-col gap-5", children: items.map((item) => (jsx("div", { children: jsx(BrowseCoachingItem, { ...item, onClick: item.hasChildren
                    ? (e) => {
                        e.preventDefault();
                        setSelectedGroups((prev) => {
                            return [...prev, item.id];
                        });
                    }
                    : () => {
                        onClose();
                    }, showChevron: item.hasChildren }) }, item.id))) }));
};
const BrowseCoaching = ({ items, setOpen, open, onNavigate, }) => {
    const groups = useMemo(() => groupItems(items), [items]);
    const [selectedGroups, setSelectedGroups] = useState(['root']);
    const handleClose = () => {
        setSelectedGroups(['root']);
        setOpen(false);
    };
    return (jsxs(Fragment, { children: [jsxs("button", { className: "flex w-full items-center justify-between text-2xl", type: "button", onClick: () => setOpen(true), children: [jsx("span", { children: "Browse Coaching" }), jsx(IconChevronRight, { className: "size-6" })] }), jsx(MobileTakeover, { open: open, children: groups.map((group, index) => (jsx(MobileFullPageMenu, { open: index === selectedGroups.length - 1, onClick: () => {
                        if (index === 0) {
                            handleClose();
                        }
                        else {
                            setSelectedGroups(selectedGroups.slice(0, index));
                        }
                    }, children: jsx("div", { className: "flex flex-col gap-2 overflow-y-auto py-5", children: Array.from(group.items).map(([parentId, items]) => {
                            return (jsx("div", { className: `${selectedGroups[index] === parentId ? 'block' : 'hidden'}`, children: jsx(BrowseCoachingItemGroup, { depth: index, selectedGroups: selectedGroups, items: items, setSelectedGroups: setSelectedGroups, onClose: () => {
                                        handleClose();
                                        onNavigate();
                                    } }) }, parentId));
                        }) }) }, index))) })] }));
};

export { BrowseCoaching };
//# sourceMappingURL=browse-coaching.js.map
